import { OutstreamVideoAdPlayer } from '@tunein/web-player-manager/outstream';
import { useEffect } from 'react';
import { player } from 'src/client/player';
import css from './OutstreamVideoAd.module.scss';

export function OutstreamVideoAd(props: { id: string }) {
  const { id } = props;

  useEffect(() => {
    let outstreamVideoAdPlayer: OutstreamVideoAdPlayer;
    let isUnmounted = false;

    const init = async () => {
      await player.ready;

      if (isUnmounted) {
        return;
      }

      outstreamVideoAdPlayer = new OutstreamVideoAdPlayer({
        id,
        playerManager: player.instance,
      });
    };

    init();

    return () => {
      isUnmounted = true;
      outstreamVideoAdPlayer?.destroy();
    };
  }, []);

  return <div id={id} className={css.container} />;
}
